import { FinancialDocumentBulkActionTypes } from "@common/constants";
import { VALID_FILE_EXTENSIONS } from "@common/constants/financial-documents";
import { ActorType } from "@common/types/auditLog";
import { z } from "zod";
import { DocumentFlowStatusFiltersSchema } from "./document-flow-status-filters.schema";

export const FinancialDocumentBulkFiltersSchema = z
    .object({
        search: z.string().optional(),
        start: z.coerce.date().optional(),
        end: z.coerce.date().optional(),
        entityIds: z.array(z.number()).optional(),
        hasNoEntity: z.boolean().optional(),
        counterpartiesIds: z.array(z.string().uuid()).optional(),
        withEmptyOrUnverifiedCounterparty: z.coerce.boolean().optional(),
        documentCategoryIds: z.array(z.string().uuid()).optional(),
        financialDocumentIds: z.array(z.number()).optional(),
        importerQueue: z.string().optional(),
        uploaderIds: z.array(z.union([z.number(), z.null()])).optional(),
        uploaderType: z.nativeEnum(ActorType).optional(),
        uploaderSources: z.array(z.string()).optional(),
        accountIds: z.array(z.number()).optional(),
        hasNoFinancialAccount: z.boolean().optional(),
        hasNoCounterparty: z.boolean().optional(),
        periodStart: z.string().date().optional(),
        periodEnd: z.string().date().optional(),
        fileExtensions: z
            .array(z.enum(VALID_FILE_EXTENSIONS as [string, ...string[]]))
            .optional(),
    })
    .merge(DocumentFlowStatusFiltersSchema);

export const FinancialDocumentBulkActionSchema = z.discriminatedUnion("type", [
    z.object({
        type: z.literal(FinancialDocumentBulkActionTypes.REMOVE),
        confirmTransactionsRemoval: z.boolean().optional(),
        skipReconciledDocuments: z.boolean().optional(),
    }),
    z.object({
        type: z.literal(FinancialDocumentBulkActionTypes.ASSIGN_ENTITY),
        entityId: z.number(),
    }),
    z.object({
        type: z.literal(
            FinancialDocumentBulkActionTypes.EDIT_DOCUMENT_CATEGORY,
        ),
        documentCategoryId: z.string().uuid().nullable(),
    }),
    z.object({
        type: z.literal(FinancialDocumentBulkActionTypes.ADD_TO_IMPORTER),
        forceRerun: z.boolean().optional(),
    }),
    z.object({
        type: z.literal(FinancialDocumentBulkActionTypes.UNMATCH_TRANSACTIONS),
    }),
    z.object({
        type: z.literal(
            FinancialDocumentBulkActionTypes.ASSIGN_FINANCIAL_ACCOUNT,
        ),
        financialAccountId: z.number().int().nullable(),
    }),
    z.object({
        type: z.literal(FinancialDocumentBulkActionTypes.ASSIGN_COUNTERPARTY),
        counterpartyId: z.string().nullable(),
    }),
    z.object({
        type: z.literal(FinancialDocumentBulkActionTypes.REVERT_RENAME),
    }),
]);
